<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    mode="passive"
    :rules="rules"
  >
    <b-form-group :description="description" :label="label" :label-for="id">
      <cleave
        :name="name"
        v-bind="$attrs"
        v-on="$listeners"
        :id="id"
        class="form-control"
        :raw="raw"
        :options="{
          numericOnly: isNumber,
          blocks: blocks || [charsCount],
          delimiter: delimiter,
          delimiterLazyShow: true,
        }"
        :class="errors.length > 0 ? 'is-invalid' : ''"
      />

      <small v-if="isOdd && ($attrs.value %2 === 0)" class="text-danger">يجب أن يكون العدد المدخل عدداً فردياً</small>

      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import Cleave from "vue-cleave-component";
import { ValidationProvider } from "vee-validate";
import { BFormGroup, BFormInput } from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
export default {
  components: {
    ValidationProvider,
    BFormInput,
    BFormGroup,
    Cleave,
  },
  props: {
    isNumber: { type: Boolean, default: () => true },
    isOdd: { type: Boolean, default: () => false },
    charsCount: { type: Number, default: () => 10 },
    delimiter: { type: String, default: () => "" },
    blocks: Array,
    raw: { type: Boolean, default: () => false },
    id: {
      type: String,
      default: () => "input",
    },
    name: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    description: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    };
  },
  computed: {
    defaultName() {
      return this.name || this.label;
    },
  },
};
</script>
